/**
 * Types for Multiple Choice Set prompt form
 */

import type { UploadedDocument } from '../types';

export type { UploadedDocument };

export type MCQSetMediaType = 'none' | 'passage' | 'image' | 'audio';

export type MCQSetSourceType = 'topic' | 'document';

export interface MultipleChoiceSetFormState {
    media: MCQSetMediaType;
    // WHY: State keys match Agent recipe settings (num_options / num_correct_min|max).
    // No ticket on main; SSOT GEN_QUESTION_CONTRACT + agents/01_hub_fe.md.
    num_questions: number;
    num_options: number;
    num_correct_min: number;
    num_correct_max: number;
    sourceType: MCQSetSourceType;
    description: string;
    documents: UploadedDocument[];
}

export const MEDIA_OPTIONS: { value: MCQSetMediaType; label: string }[] = [
    { value: 'none', label: 'None' },
    { value: 'passage', label: 'Passage' },
    { value: 'image', label: 'Image' },
    { value: 'audio', label: 'Audio' },
];

// WHY: Mirror Agent ScqQuestionTypeConfig / _ChoiceConfigBase for Dropdown AI
// QT_MULTIPLE_CHOICE_SET_BASE leaf (default scq). Form is SCQ-locked: correct
// answers always min=max=1 (Mcq multi-correct is out of scope until product asks).
export const MIN_NUM_QUESTIONS = 1;
export const MAX_NUM_QUESTIONS = 20;
export const MIN_NUM_OPTIONS = 2;
export const MAX_NUM_OPTIONS = 8;

export const DEFAULT_FORM_STATE: MultipleChoiceSetFormState = {
    media: 'none',
    num_questions: 1,
    num_options: 4,
    num_correct_min: 1,
    num_correct_max: 1,
    sourceType: 'topic',
    description: '',
    documents: [],
};

export const DOCUMENT_ACCEPT = '.pdf,.txt,.doc,.docx,.rtf';
